<template>
  <div>
    <v-app-bar
        v-if="isLogin"
        color="primary"
        dark
        :style="`${language=='ar' ? 'border-bottom-left-radius: 0!important;' : null}`"
        elevate-on-scroll
        extended
        tile
        extension-height="1"
      >
      <v-app-bar-nav-icon v-if="isLogin" @click="()=>{
        $vuetify.goTo(0, {
          duration: 0
        })
        drawer = true}">
      </v-app-bar-nav-icon>
      <span 
          v-if="site && site.name && !site.logo" 
          :class="`${language == 'ar' ? 'arFont' : null}`"
          @click="goTo('/')"
          style="cursor:pointer;"
        >{{ site.name.toUpperCase() }}
      </span>
      <img 
        @click="goTo('/')" 
        v-if="site && site.name && site.logo" 
        :src="site.logo" 
        alt="site.name" 
        style="width: 80px;cursor:pointer;">
      <v-spacer></v-spacer>

      <v-toolbar-title style="width: 65%;color:#fff;" :class="`${arabic?'arFont':'enFont'}`">
        <!-- <v-text-field
          label="Search"
          autofocus
          dense
          filled
          clearable
          full-width
          hide-details
          rounded
        ></v-text-field> -->
        {{routeTitle}}
      </v-toolbar-title>
        
      <v-spacer></v-spacer>
      <v-btn icon small v-show="false" color="black" class="add-button">
        <v-icon>cloud</v-icon>
      </v-btn>
      <v-menu
        left
        bottom
        transition="scale-transition"
        origin="center center"

      >
        <template v-slot:activator="{ on }">
          <v-btn :loading="globalLoading" v-if="false" icon small v-on="on" color="white">
            <v-icon v-if="!isLogin">person_outline</v-icon>
            <v-icon v-if="isLogin">person</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item class="py-0 my-0" v-if="isLogin">
            <v-list-item-title class="py-0 my-0">
              <v-btn @click="profileDialog()" small depressed color="white">edit profile</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="py-0 my-0" v-if="!isLogin">
            <v-list-item-title class="py-0 my-0">
              <v-btn @click="registerDialog()" small depressed color="white">Register</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="py-0 my-0" v-if="!isLogin">
            <v-list-item-title class="py-0 my-0">
              <v-btn @click="signDialog()" small depressed color="white">sign in</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="py-0 my-0" v-if="isLogin">
            <v-list-item-title class="py-0 my-0">
              <v-btn small depressed color="white" @click="signOut()">sign out</v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-progress-linear v-if="globalLoading" slot="extension" color="primary" height="3" :indeterminate="true" class="ma-0"></v-progress-linear>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :right="language == 'ar'"
      :left="language == 'en'"
      v-if="isLogin"
      class="elevation-2"
      app
      :permanent="$vuetify.breakpoint.md"
      dark
      color="primary"
      clipped
    >
      <v-row>
        <v-col cols="12" class="text-center">
          <img 
            @click="goTo('/')" 
            v-if="site && site.name && site.logo" 
            :src="site.logo" 
            alt="site.name" 
            style="height:60px;cursor:pointer;">
        </v-col>
      </v-row>
      <v-divider class="mx-3"></v-divider>
      <v-row class="py-5">
        <v-col cols="12" class="text-center py-1 pt-2"  >
          <v-avatar
            v-if="user && user.image" 
            size="40"
          >
            <img 
            @click="goTo('/')" 
            :src="user.image" 
            :alt="site.image" 
            style="width: 60px;cursor:pointer;">
          </v-avatar>
          
          <v-avatar
            size="40"
            v-if="user && user.name && !user.image"
            color="white darken-2"
            style="font-size:20px;"
          >
            {{user.name.slice(0,1)}}
          </v-avatar>
          <v-avatar
            size="10"
            class="mb-7"
            :color="online?'success':'error'"
          >
          </v-avatar>
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} text-center py-1 pb-2`" v-if="user && user.name" style="font-size:12px;color:#fff">
          {{user.name}}
        </v-col>
      </v-row>
      <v-divider class="mx-3"></v-divider>
      <v-list dark dense nav v-for="(item, i) in items" :key="'item-' + i" class="customMenu">
        <v-list-item v-if="!item.subs" @click="goTo(item.path)">
          <v-list-item-icon>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :class="`${arabic?'arFont':'enFont'}`">{{i18n[item.text]}}</v-list-item-title>
        </v-list-item>
        <v-list-group
          v-model="open[i]"
          v-if="item.subs"
          class="white--text specialMenu"
          dark
          :prepend-icon="item.icon"
          append-icon="keyboard_arrow_down"
        >
          <template v-slot:activator class="my-0">
            <v-list-item-title :class="`${arabic?'arFont':'enFont'} white--text my-0 `">{{i18n[item.text]}}</v-list-item-title>
          </template>

          <v-list-item
            v-for="(sub, i) in item.subs"
            :key="i+'sub'"
            link
            @click="goTo(sub.path)"
          >
            
            <v-list-item-title :class="`${arabic?'arFont':'enFont'}`" v-text="i18n[sub.text]"></v-list-item-title>
            <v-list-item-icon>
              <v-badge left overlap v-if="sub.text == 'notifications'" color="primary darken-4">
                <span slot="badge" style="font-size:11px;" class="white--text">{{notifications}}</span>
                <v-icon v-text="sub.icon"></v-icon>
              </v-badge>
              <v-icon v-else v-text="sub.icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-divider class="mx-3 mt-3"></v-divider>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block text @click="switchLanguage('en')" v-if="language == 'ar'" class="mb-1">
            english
          </v-btn>
          <v-btn block text v-if="language == 'en'" @click="switchLanguage('ar')" :class="`mb-1 arFont`">
            عربي
          </v-btn>
          <!-- <v-btn block @click="getUser()" :class="`${arabic?'arFont':'enFont'} primary mb-1`" text>
            get user
          </v-btn> -->
          <v-btn block @click="signOut()" :class="`${arabic?'arFont':'enFont'} primary`" text>
            {{i18n.logout}}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {firebase, auth, db, store} from '@/fb';


export default {
  components: { },
  data() {
    return {
      drawer: false,
      group:null,
      value:null,
      open: [],
    }
  },
  methods: {
    async getUser() {
      let a = await this.$store.dispatch('getUser')
    },
    enLanguage(){
      this.$emit('changeLang', 'en')
    },
    arLanguage(){
      this.$emit('changeLang', 'ar')
    },
    clearStore(){
      this.$store.state.access_token = null
      this.$store.state.user = null
      this.$store.state.uid = null
      this.$store.state.centralLogin = false
      this.$store.state.menu = []
      this.$store.state.globalLoading = []
      this.$store.state.users = []
      this.$store.state.goals = []
      this.$store.state.keyResults = []
      this.$store.state.initiatives = []
      this.$store.state.documents = []
      this.$store.state.notifications = []
      this.$store.state.approvals = []
      this.$store.state.usersLevels = []
      this.$store.state.reports = []
      this.$store.state.othersGoals = []
    },
    async signOut() {
      try {
        await this.$store.dispatch('logout')
      } catch (error) {console.log(error)}
      this.clearStore()
    },
    goTo(path) {
      this.$router.push(path).catch(err => {})
    },
    switchLanguage(l) {
      this.$store.state.language = l
      if(l=='ar') {
        this.$vuetify.rtl = true
      } else {
        this.$vuetify.rtl = false
      }
    }
  },
  props: {
    
  },
  computed:{
    site(){
      return this.$store.state.site
    },
    items() {
      const items = [...this.$store.state.modelMenu]
      let user = {...this.$store.state.user}
      let role = user.role
      console.log(role, items)
      this.$store.menu = items.map(x=>{
        if(x.subs) {
          return {
            ...x, 
            subs:x.subs.filter(x=>x.roles.includes(role))
          }
        } else if(x.roles.includes(role)) {
          return {
            ...x
          }
        }
      }).filter(x=>x.roles.includes(role))
      return this.$store.menu
    },
    access(){
      let user = {...this.$store.state.user}
      let role = user.role
      let menu = this.$store.state.modelMenu
      let main = menu.filter(x => !x.subs)
      let subs = [].concat(...menu.filter(x => x.subs).map(x => x.subs))
      let all = main.concat(subs)
      let c = all.filter(x=>x.text == this.$route.name)[0]
      let e = c.roles.includes('special') && this.$store.state.user && !this.$store.state.user.special
      let a = c ? c.roles.includes(role) : false
      return a || e
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    online(){
      return this.$store.state.online
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.modelMenu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.modelMenu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    notifications(){
      return this.$store.state.notifications.filter(x=>!x.view).length
    },
  },
  created () {

  },
  mounted() {
    
  },
}
</script>

<style>
.v-toolbar__extension {
  padding: 0 !important;
}
.v-badge__badge {
  
}
.v-badge__badge {
  /* top: 2px !important; */
  height: 13px !important;
  min-width: 10px !important;
}
.specialMenu * {
  color:white!important;
}
.specialMenu .v-list-item__icon {
  color:white!important;
}
</style>